import React from 'react';
import { Link } from 'react-router-dom';

export function Text({ className = '', children, ...props }) {
  return (
    <p
      className={`text-sm text-zinc-600 dark:text-zinc-400 ${className}`}
      {...props}
    >
      {children}
    </p>
  );
}

export function TextLink({ className = '', href, children, ...props }) {
  return (
    <Link
      to={href}
      className={`font-medium text-brand-red-500 hover:text-brand-red-600 dark:text-brand-red-400 dark:hover:text-brand-red-300 ${className}`}
      {...props}
    >
      {children}
    </Link>
  );
}

export function Strong({ className = '', children, ...props }) {
  return (
    <strong
      className={`font-medium text-zinc-950 dark:text-white ${className}`}
      {...props}
    >
      {children}
    </strong>
  );
}

export default { Text, TextLink, Strong }; 